"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var deal = {
    SELECT_DEALER: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation SelectDealer($dealId: String!, $dealerId: String!) {\n      selectDealer(dealId: $dealId, dealerId: $dealerId) {\n        uuid\n      }\n    }\n  "], ["\n    mutation SelectDealer($dealId: String!, $dealerId: String!) {\n      selectDealer(dealId: $dealId, dealerId: $dealerId) {\n        uuid\n      }\n    }\n  "]))),
};
exports.default = deal;
var templateObject_1;
